import React, { PureComponent, PropTypes } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';

import './SeatListRowHeader.scss';

export default class SeatListRowHeader extends PureComponent {
  static propTypes = {
    flightRow: ImmutablePropTypes.mapContains({
      flightSeats: ImmutablePropTypes.listOf(
        ImmutablePropTypes.mapContains({
          seatNumber: PropTypes.string,
        }),
      ),
    }),
  };

  render() {
    const { flightRow } = this.props;
    const numberOfSeats = flightRow.get('flightSeats').size;

    return (
      <div className={`seat-list-row-header seat-list-row-header--size-${numberOfSeats}`}>
        { flightRow.get('flightSeats').map((seat, index) => (
          <div key={index} className="seat-list-row-header__seat">
            { seat.get('seatNumber') }
          </div>
        ))}
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/AirlineSeatSelection/SeatListRowHeader.jsx
 **/